
































export default {
	name: 'JobInviteDialog',

	props: {
		job_application_uuid: {
			required: false,
			type: String,
		},

		applicant_uuid: {
			required: true,
			type: String,
		},

		applicant_name: {
			required: true,
			type: String,
		},
	},

	data() {
		return {
			isForListedJob: true,
		};
	},
};
